<script>
export default {
  name: 'home-top',
  props: {
    data: {
      type: Array,
      default: () => [],
    },
  },
  render() {
    return (
      <div class="home-top">
        {(this.data || []).map((e) => {
          return (
            <div class="home-top-item" onClick={() => e.onClick()}>
              <div>{e.value}</div>
              <div>{e.name}</div>
            </div>
          )
        })}
      </div>
    )
  },
}
</script>
<style lang="less" scoped>
.home-top {
  display: flex;
  align-items: center;
  height: 101px;
  width: 100%;
  background: white;
  margin: 10px 0;
  .home-top-item {
    display: flex;
    flex: 1;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: relative;
    font-family: 'PingFang SC Normal', 'PingFang SC';
    font-weight: 500;
    font-style: normal;
    font-size: 20px;
    color: #515a6e;
    &:not(:last-child)::after {
      position: absolute;
      right: 0px;
      top: 0px;
      bottom: 0px;
      width: 1px;
      background: rgb(229, 231, 233);
      content: '';
    }
  }
}
/deep/.home-top-item {
  div {
    &:nth-of-type(2) {
      font-size: 14px;
      color: #515a6e;
    }
  }
}
</style>
